import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter, HashRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"

import App from "./App"
import { store } from "./store/index"
import { theme } from "./theme"
import { AuthProvider } from "./contexts/AuthContext"
import { ErrorProvider } from "./contexts/ErrorContext"
import "./i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const base = process.env.PUBLIC_URL ?? ""
    const swUrl = `${base}/sw.js`.replace(/\/+/g, "/")
    navigator.serviceWorker.register(swUrl).catch(() => {
      /* ignore registration errors — app works without SW */
    })
  })
}

root.render(
  // Temporarily disabled StrictMode to test API call deduplication
  // <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      <HashRouter>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
              <ErrorProvider>
                <App />
              </ErrorProvider>
            </AuthProvider>
          </ThemeProvider>
        </HashRouter>
      </QueryClientProvider>
    </Provider>
  // </React.StrictMode>
  ,
)
